import React from "react";
import CustomTemplates from "./CustomTemplate";
import { cashvoucherPackages } from "../../../components/template/CustomTemplate/Pages/CashVoucherPackages";

const CashVoucher = () => {
 
  return ( //               cash-voucher 
    <CustomTemplates slug={"cash-vouchers"} attributes={cashvoucherPackages} />
  );
};

export default CashVoucher;
